import { motion } from 'framer-motion';

const CallIn = ({ child, direction = 'left' }) => {
    // Default motion directions
    const directions = {
        up: { initial: { opacity: 0, y: -50 }, animate: { opacity: 1, y: 0 } },
        right: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 } },
        bottom: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 } },
        left: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 } },
    };

    // Choose the correct motion values based on the direction prop
    const animation = directions[direction] || directions.left;

    return (
        <motion.div
            initial={animation.initial}
            animate={animation.animate}
            transition={{ duration: 1 }}
        >
            {child}
        </motion.div>
    );
};

export default CallIn;
